import React from "react";
import { ArrowUpRight } from "lucide-react";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";
import { ARTICLES } from "./resourcesData.jsx";
import NextSteps from "./NextSteps.jsx";

function PageFrame({ children }) {
  return (
    <div className="min-h-screen bg-paper text-nearblack font-sans antialiased">
      <Nav heroVisible={false} />
      {children}
      <Footer />
    </div>
  );
}

export default function ResourcesPage() {
  return (
    <PageFrame>
      {/* Intro */}
      <section className="pt-32 md:pt-44 pb-12 md:pb-16" data-testid="resources-intro">
        <div className="max-w-[760px] mx-auto px-6 md:px-10">
          <p className="eyebrow" data-testid="resources-eyebrow">
            Resources
          </p>
          <h1
            data-testid="resources-headline"
            className="font-serif text-nearblack mt-7 leading-[1.05] text-balance"
            style={{ fontSize: "clamp(2.4rem, 5.5vw, 4rem)", fontWeight: 300 }}
          >
            Things worth understanding about{" "}
            <em className="italic text-camel" style={{ fontWeight: 300 }}>money</em>.
          </h1>
          <span className="block w-[60px] h-px bg-camel mt-10" />
          <p
            className="mt-10 font-serif italic text-camel max-w-[640px]"
            style={{ fontSize: "clamp(1.25rem, 2.2vw, 1.55rem)", fontWeight: 300, lineHeight: 1.5 }}
          >
            Short reads on financial systems, common misconceptions, and the strategy behind
            Infinite Banking.
          </p>
        </div>
      </section>

      {/* Article cards */}
      <section className="pb-20 md:pb-24" data-testid="resources-list">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-12">
            {ARTICLES.map((a) => (
              <article
                key={a.slug}
                data-testid={`resource-card-${a.slug}`}
                className="flex flex-col group"
              >
                <a href={`/resources/${a.slug}`} className="block overflow-hidden bg-nearblack/5">
                  <img
                    src={a.image}
                    alt={a.imageAlt}
                    loading="lazy"
                    className="w-full aspect-square object-cover transition-transform duration-[700ms] ease-out group-hover:scale-[1.025]"
                  />
                </a>
                <p className="eyebrow mt-7">{a.eyebrow}</p>
                <h2
                  className="font-serif text-nearblack mt-3 leading-[1.18]"
                  style={{ fontSize: "clamp(1.35rem, 2.1vw, 1.5rem)", fontWeight: 400 }}
                >
                  <a
                    href={`/resources/${a.slug}`}
                    data-testid={`resource-link-${a.slug}`}
                    className="hover:text-camel transition-colors"
                  >
                    {a.title}
                  </a>
                </h2>
                <p className="mt-4 text-nearblack/75 font-light text-[15px] leading-[1.7]">
                  {a.description}
                </p>
                <p
                  className="mt-5 text-stonegrey uppercase tracking-[0.22em]"
                  style={{ fontSize: "10.5px", fontWeight: 500 }}
                >
                  By Liz DiRocco
                </p>
                <a
                  href={`/resources/${a.slug}`}
                  data-testid={`resource-read-${a.slug}`}
                  className="mt-5 inline-flex items-center gap-1.5 text-camel hover:text-nearblack transition-colors uppercase tracking-[0.22em] self-start"
                  style={{ fontSize: "11px", fontWeight: 600 }}
                >
                  Read article
                  <ArrowUpRight className="w-3.5 h-3.5" />
                </a>
              </article>
            ))}
          </div>
        </div>
      </section>

      <NextSteps />
    </PageFrame>
  );
}
